import React from 'react';
import { Bus } from 'lucide-react';

const WebsiteLoading = () => {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      <div className="text-center">
        {/* Bus icon with animation */}
        <div className="mb-4">
          <Bus className="w-16 h-16 text-gray-600 animate-bounce mx-auto" />
        </div>
        
        {/* Loading text */}
        <p className="text-gray-600 text-lg">Loading...</p>
      </div>
    </div>
  );
};

export default WebsiteLoading;
